import get from 'lodash/get'

export const getters = {
  components (state) {
    return get(state, 'components.value', {})
  },
  componentsStatus (state) {
    return {
      loaded: get(state, 'components.loaded', false),
      loading: get(state, 'components.loading', false),
      error: get(state, 'components.error', null)
    }
  },
  initialFilterCriteria (state, getters) {
    const lastFilterCriteria = JSON.parse(JSON.stringify(getters.lastSelectedCriteria))
    return lastFilterCriteria || null
  },
  availableFilterCriteria (state) {
    return get(state, 'componentsFilter.availableFilterCriteria.value', [])
  },
  availableFilterCriteriaStatus (state) {
    return {
      loading: get(state, 'componentsFilter.availableFilterCriteria.loading', true),
      loaded: get(state, 'componentsFilter.availableFilterCriteria.loaded', false),
      error: get(state, 'componentsFilter.availableFilterCriteria.error')
    }
  },
  lastSelectedCriteria (state) {
    return get(state, 'componentsFilter.selectedCriteria')
  }
}
